export class FeedbackApi {
    client;
    constructor(client) {
        this.client = client;
    }
    async createPost(params) {
        return this.client.post('/api/feedback', params);
    }
    async listPosts(params, requestOptions) {
        const qs = new URLSearchParams();
        if (params?.page)
            qs.set('page', String(params.page));
        if (params?.limit)
            qs.set('limit', String(params.limit));
        if (params?.sort)
            qs.set('sort', params.sort);
        if (params?.category)
            qs.set('category', params.category);
        if (params?.statuses?.length)
            qs.set('statuses', params.statuses.join(','));
        if (params?.hasStaffResponse !== undefined) {
            qs.set('hasStaffResponse', String(params.hasStaffResponse));
        }
        if (params?.search)
            qs.set('search', params.search);
        const query = qs.toString();
        return this.client.get(`/api/feedback${query ? `?${query}` : ''}`, requestOptions);
    }
    async getRoadmapTimeline(requestOptions) {
        return this.client.get('/api/feedback/roadmap', { ...requestOptions, cache: 'no-store' });
    }
    async getPost(postId) {
        return this.client.get(`/api/feedback/${encodeURIComponent(postId)}`);
    }
    async upvotePost(postId) {
        return this.client.post(`/api/feedback/${encodeURIComponent(postId)}/upvote`, {});
    }
    async removeUpvote(postId) {
        return this.client.delete(`/api/feedback/${encodeURIComponent(postId)}/upvote`);
    }
    async addComment(postId, params) {
        return this.client.post(`/api/feedback/${encodeURIComponent(postId)}/comments`, params);
    }
    async updateStatus(postId, params) {
        return this.client.patch(`/api/feedback/${encodeURIComponent(postId)}/status`, params);
    }
    async updateRoadmap(postId, params) {
        return this.client.patch(`/api/feedback/${encodeURIComponent(postId)}/roadmap`, params);
    }
    async getNotificationPrefs() {
        return this.client.get('/api/feedback/notification-prefs');
    }
    async updateNotificationPrefs(params) {
        return this.client.put('/api/feedback/notification-prefs', params);
    }
}
//# sourceMappingURL=feedback-api.js.map